import {RichText} from '../RichText'

export interface BlockDocumentHeaderProps{
  callout?: string | null
  title: string
}

export const DocumentHeader = ({callout, title}: BlockDocumentHeaderProps) => {
  return (
    // use grid instead of flex flex-col to allow break-words to work more easily on children
    <div className={'grid gap-spacing-8'}>
      {callout ? (
        <RichText
          as={'p'}
          content={callout}
          allowedTags={['span', 'p']}
          className={'min-w-0 break-words text-p1'}
        />
      ) : null}
      <RichText
        as={'h1'}
        className={'min-w-0 break-words text-h1-xs @block-medium:text-h1'}
        content={title}
        allowedTags={['span', 'p']}
      />
    </div>
  )
}
